export default {
    name: "ArticleComments",
    data() {
        return {
            disqusCommentsID: ""
        };
    },
    created() {
        const currentID = window.location.pathname.replace(/\//, "");
        this.disqusCommentsID = currentID;
    }
};



// WEBPACK FOOTER //
// ./src/components/ArticleComments/ArticleComments.js